
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trial-membership",
      function () {
        return require("private-next-pages/trial-membership/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trial-membership"])
      });
    }
  